import { Component } from 'react';
import { connect } from 'react-redux';

import { Money } from 'common/components/layout';
import { imageFile } from 'common/helpers/miscHelper';
import { addItemToShipment } from 'redux/clubMemberShipments/actions';

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: props.item.minQuantity || 1,
      error: null,
      isSubmitting: false
    };
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });
    const { props, state } = this;
    const { clubMemberShipmentId } = this.props;
    const { productVariantId } = props.item;
    const item = {
      quantity: Number(state.quantity),
      productVariantId
    };
    const successFunction = () => {
      this.setState({ isSubmitting: false });
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    if (state.quantity === '') {
      this.setState({ error: 'Invalid Quantity', isSubmitting: false });
    } else {
      props.addItemToShipment(
        clubMemberShipmentId,
        item,
        successFunction,
        errorFunction
      );
    }
  };

  handleQuantity = (e) => {
    const input = e.target.value;
    const quantity = input.replace(/[^0-9]/g, '');
    this.setState({ quantity, error: null });
  };

  render() {
    const { item, clubPackage, clubMemberShipment, settings } = this.props;
    if (!item.isAvailableOnWeb) {
      return null;
    }
    const totalItemsInShipment = clubMemberShipment.items.reduce(
      (total, i) => total + i.quantity,
      0
    );
    const itemInShipment = clubMemberShipment.items.find(
      (pItem) => pItem.productVariantId === item.productVariantId
    );
    const isItemInShipment = (itemInShipment && true) || false;
    const { error, isSubmitting } = this.state;
    const { minQuantity, maxQuantity } = calculateQuantity(
      item,
      totalItemsInShipment,
      clubPackage.minQuantityInShipment,
      isItemInShipment
    );
    const { state } = this;
    return (
      <div className="c7-clubpackage-product">
        <div className="c7-clubpackage-product__photo">
          <img
            src={imageFile(item.image, 'small')}
            alt={item.productVariantTitle}
          />
        </div>

        <div className="c7-clubpackage-product__info">
          <div className="c7-clubpackage-product__title">
            {item.productTitle}
            <div className="c7-cart-items__title__variant">
              {item.productVariantTitle}
            </div>
          </div>
          <div className="c7-clubpackage-product__min-max">
            {renderOrder(minQuantity, maxQuantity, itemInShipment)}
          </div>
          <form
            action=""
            onSubmit={this.submitForm}
            className="c7-clubpackage-product__variant"
          >
            {error && <span aria-describedby="qtyerror">{error}</span>}

            {renderRegularPrice(item, settings)}

            {renderClubMemberPrice(item, settings)}

            {renderQuantity(
              state.quantity,
              this.handleQuantity,
              minQuantity,
              maxQuantity,
              error,
              isSubmitting
            )}
          </form>
        </div>
      </div>
    );
  }
}

const calculateQuantity = (
  item,
  totalItemsInShipment,
  minQuantityInShipment,
  isItemInShipment
) => {
  let { minQuantity } = item;
  const { maxQuantity } = item;
  // min quantity can be 1 if item exists in shipment
  if (isItemInShipment || minQuantity === 0) {
    minQuantity = 1;
  }
  return { minQuantity, maxQuantity };
};

const renderOrder = (minQuantity, maxQuantity, itemInShipment) => {
  if (!minQuantity || maxQuantity === 0) {
    return null;
  }
  if (itemInShipment && maxQuantity) {
    if (maxQuantity === minQuantity) {
      return <>Add {minQuantity} more.</>;
    }
    return (
      <>
        Add from {minQuantity} to {maxQuantity} more.
      </>
    );
  }
  if (maxQuantity) {
    if (maxQuantity === minQuantity) {
      return null;
    }
    return (
      <>
        Order from {minQuantity} to {maxQuantity}.
      </>
    );
  }
  return null;
};

const renderQuantity = (
  quantity,
  handleQuantity,
  minQuantity,
  maxQuantity,
  error,
  isSubmitting
) => {
  if (!minQuantity || maxQuantity === 0) {
    return null;
  }
  let describedby;
  if (error) {
    describedby = { 'aria-describedby': 'qtyerror' };
  }

  if (maxQuantity && maxQuantity - minQuantity < 12) {
    // show select box
    const selectArray = [];
    for (let i = minQuantity; i <= maxQuantity; i += 1) {
      selectArray.push(i);
    }

    return (
      <>
        <label htmlFor="quantity">
          <select
            className="c7-clubpackage-product__select"
            name="quantity"
            value={quantity}
            onChange={handleQuantity}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...describedby}
          >
            {selectArray.map((i) => (
              <option value={i} key={i}>
                {i}
              </option>
            ))}
          </select>
        </label>
        &nbsp;
        <button type="submit" className="c7-button-alt" disabled={isSubmitting}>
          Add
        </button>
      </>
    );
  }
  return (
    <>
      <label htmlFor="quantity">
        <input
          name="quantity"
          type="text"
          value={quantity}
          onChange={handleQuantity}
          inputMode="numeric"
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...describedby}
        />
      </label>

      <button type="submit" className="c7-button-alt" disabled={isSubmitting}>
        Add
      </button>
    </>
  );
};

const renderClubMemberPrice = (item, settings) => {
  if (item.price >= item.comparePrice) {
    return null;
  }
  return (
    <div className="c7-clubpackage-product__variant__message">
      Club Member Price{' '}
      <strong>
        <Money number={item.price} settings={settings} />
      </strong>
    </div>
  );
};

const renderRegularPrice = (item, settings) => {
  if (item.price >= item.comparePrice) {
    return (
      <div className="c7-clubpackage-product__variant__price">
        <Money number={item.comparePrice} settings={settings} />
      </div>
    );
  }
  return (
    <div className="c7-clubpackage-product__variant__price  c7-clubpackage-product__variant__price--compare-at-price">
      <Money number={item.comparePrice} settings={settings} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps, { addItemToShipment })(Item);
